import React from "react";
import { useForm, Controller } from "react-hook-form";
import { FileDropzone, Icon, TutorialContainer } from "../../../_components";

export function DefaultMapPage({ onSubmit, store, formRef, tooltipID = "" }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      map: store.map || null,
    },
  });
  return (
    <div className="chronos-default-map-page">
      {/* GIF */}
      <TutorialContainer
        type="video"
        url="https://wa-cdn.nyc3.cdn.digitaloceanspaces.com/chronos/480bee5a-dc6f-46e5-bb3f-351cf3fed717.webm"
      />
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <div className="content-page-wrapper">
          <h2 className="chronos-wizard-page-title">Choose your Default Map</h2>
          <p className="chronos-wizard-text">
            Upload an image of your first map. You can add, remove and edit maps
            later.&nbsp;
            <Icon
              icon="fas fa-question-circle fa-fw"
              data-for={tooltipID}
              data-tip={`Suggested: 4kx2.5k pixels, webp, or jpg`}
            />
          </p>

          <p className="chronos-wizard-hint">
            You can right-click on your map (after this set-up) to add markers!
          </p>
          <div className="form-group">
            <Controller
              control={control}
              name="map"
              id="map"
              render={({ value, onChange }) => (
                <FileDropzone
                  value={value}
                  onChange={onChange}
                  className="chronos-file-dropzone"
                />
              )}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
